import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { useEffect, useState } from 'react';
import { ServerRequestProtected, ServerRequestPublic } from '../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../utils/Enum';
import Loader from '../../../../../../../shared/Loader/Loader';
import isNull from '../../../../../../../../utils/NullChecking';
import { IconAlertGradient } from '../../../../../../../shared/IconsComponent/icons';
import { saveAs } from "file-saver"

const ViewTranscript = (props) => {
    const { viewTranscript, CloseViewTranscript, encounterID } = { ...props }
    console.log("ViewTranscript Rendered");
    const [emptyTranscript, setEmptyTranscript] = useState(false)
    const [transcriptedData, setTranscriptedData] = useState()
    const API_URL_AI = enumUtil.controller.AINoteWorkflows
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        setIsLoading(true)
        ServerRequestProtected(
            `${API_URL_AI}/Transcript/${encounterID}`,
            'GET'
        ).then((response) => {
            setIsLoading(false)
            setTranscriptedData(response)
            if (response.transcript === '') {
                setEmptyTranscript(true)
            }
        }).catch((error) => {
            setIsLoading(false)
            setTranscriptedData()
            setEmptyTranscript(true)
            NotificationHandler(error.response.data.error, enumUtil.enumtoaster.error);
        })
    }, [encounterID])
    const renderTranscript = (transcript) => {
        if (!transcript) return null;

        const normalized = transcript
            // Handle double-escaped first (must come before single)
            .replace(/\\\\r\\\\n/g, '\n')
            .replace(/\\\\n/g, '\n')
            .replace(/\\\\r/g, '\n')
            .replace(/\\\\t/g, ' ')
            // Then single-escaped
            .replace(/\\r\\n/g, '\n')
            .replace(/\\n/g, '\n')
            .replace(/\\r/g, '\n')
            .replace(/\\t/g, ' ')
            // Real control characters (just in case)
            .replace(/\r\n/g, '\n')
            .replace(/\r/g, '\n')
            .replace(/\t/g, ' ')
            // Unicode line separators
            .replace(/\u2028|\u2029/g, '\n')
            // Collapse 3+ newlines into 2 max                  
            .replace(/\n{3,}/g, '\n\n')
            .trim();

        const lines = normalized
            .split('\n')
            .map(line => line.trim())
            .filter(line => line.length > 0);

        return (
            <div className="transcript-container d-flex flex-column gap-6">
                {lines.map((line, index) => {
                    const [Speaker, ...rest] = line.split('\b');   // if you still have \b separating speaker
                    const message = rest.join('');
                    return (
                        <p key={index} className="text lh-normal">
                            {Speaker && <span className="font-sb">{Speaker}</span>}
                            {message}
                        </p>
                    )
                })}
            </div>
        );
    };
    const handleDownloadAudioTranscript = () => {
        setIsLoading(true)
        ServerRequestPublic(API_URL_AI + "/DownloadEncounterFiles?EncounterID=" + encounterID, 'GET', '', "Download", '')
            .then((response) => {
                let blob = new Blob([response]);
                saveAs(blob, "Resources" + ".zip");
                setIsLoading(false)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
    }
    return (
        <div className={`ar-enconter-ai-note ${viewTranscript ? "active__notes" : ""}`}>
            {isLoading ? <Loader /> : null}
            <div className="d-flex flex-column gap-12">
                <div className="d-flex align-items-center justify-content-between px-10">
                    <p className='heading fs-14 dark-clr '></p>
                    <i className='icon-x-cros fs-20 dark-clr' onClick={CloseViewTranscript}></i>
                </div>

                <div className="ar-scroll-content hover-scrollbar px-10 d-flex flex-column gap-12">
                    {/* <div className="ar_bg-content p-2 d-flex flex-column gap-6">
                        <div className="d-flex gap-1">
                            <span className="d-flex mt-3px">
                                <IconAlertGradient />
                            </span>
                            <p className='text lh-normal'>
                                <span className="linear-blue-color font-sb text-decoration-underline cursor-pointer" onClick={handleDownloadAudioTranscript}>Click Here</span>
                                <span className="font-sb"> to download the session audio and transcript.</span> A download link will be sent to your registered email address.
                            </p>
                        </div>
                    </div> */}
                    {viewTranscript && (
                        <>
                            {transcriptedData ? renderTranscript(transcriptedData?.transcript) :
                                <p className='text fs-11 text-black'>{isLoading ? 'Getting transcript...' : 'Transcript not found'} </p>
                            }
                        </>
                    )}
                    {emptyTranscript ? <p className="text fs-11">
                        <span className="font-sb"> No Transcription Found</span>
                    </p> : ''}
                </div>
            </div>
        </div>
    )
}

export default ViewTranscript
